var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{staticStyle:{"margin-top":"25em","margin-bottom":"25em"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"d-flex":"","xs8":""}},[_c('v-card')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }